// @ts-ignore
import createVonageTFLiteSimdModule from "./tflite-simd";

export interface TFLite extends EmscriptenModule {
    _getModelBufferMemoryOffset(): number;
    _getInputMemoryOffset(): number;
    _getInputHeight(): number;
    _getInputWidth(): number;
    _getInputChannelCount(): number;
    _getOutputMemoryOffset(): number;
    _getOutputHeight(): number;
    _getOutputWidth(): number;
    _getOutputChannelCount(): number;
    _loadModel(bufferSize: number): number;
    _runInference(): number;
    _isGPUEnabled(): boolean;
}

export class VonageTFLiteInfo {
    selectedTFLite!: TFLite;
    isSIMDSupported: boolean = false;
    isThreadsSupported: boolean = false;
    inputWidth: number = 0;
    inputHeight: number = 0;
    inputChannelCount: number = 0;
    inputMemoryOffset: number = 0;
    outputWidth: number = 0;
    outputHeight: number = 0;
    outputChannelCount: number = 0;
    outputMemoryOffset: number = 0;
}

const defaultWasmBaseAssetsUri: string =
    "https://d3opqjmqzxf057.cloudfront.net/vonage-tensorflow-wasm/tflite-simd-wasm/1.1.3/";
const defaultModelAssetUriPath: string =
    "https://d3opqjmqzxf057.cloudfront.net/ml/selfie_segmentation/4.0.0/selfie_segmentation_landscape.tflite";

export async function loadSelfieSegmentation(
    wasmBaseAssetsUri: string = defaultWasmBaseAssetsUri,
    modelAssetUriPath: string = defaultModelAssetUriPath
): Promise<VonageTFLiteInfo> {
    let tfliteInfo: VonageTFLiteInfo = new VonageTFLiteInfo();

    var promise = new Promise<VonageTFLiteInfo>(function (resolve, reject) {
        async function loadTFLite(): Promise<TFLite> {
            const helper = {
                locateFile: function (path: string) {
                    return wasmBaseAssetsUri + path;
                },
            };
            return (createVonageTFLiteSimdModule as any)(helper);
        }

        async function loadTFLiteModel(tflite: TFLite): Promise<void> {
            return new Promise<void>(async (resolve, reject) => {
                const newSelectedTFLite = tflite;

                if (typeof newSelectedTFLite === "undefined") {
                    return reject(`TFLite backend unavailable: wasmSimd`);
                }

                let modelUrl = modelAssetUriPath;
                console.log("TFLite modelUrl: " + modelUrl);
                try {
                    const modelResponse = await fetch(modelUrl);

                    const model = await modelResponse.arrayBuffer();
                    console.log("Model buffer size:", model.byteLength);

                    const modelBufferOffset =
                        newSelectedTFLite._getModelBufferMemoryOffset();
                    console.log(
                        "Model buffer memory offset:",
                        modelBufferOffset
                    );
                    console.log("Loading model buffer...");
                    newSelectedTFLite.HEAPU8.set(
                        new Uint8Array(model),
                        modelBufferOffset
                    );
                    const loadModelResult = newSelectedTFLite._loadModel(
                        model.byteLength
                    );
                    console.log("Load model result:", loadModelResult);
                    if (loadModelResult !== 0) {
                        reject("Cannot load model");
                        return;
                    }
                    tfliteInfo.inputWidth = newSelectedTFLite._getInputWidth();
                    tfliteInfo.inputHeight =
                        newSelectedTFLite._getInputHeight();
                    tfliteInfo.inputChannelCount =
                        newSelectedTFLite._getInputChannelCount();
                    tfliteInfo.inputMemoryOffset =
                        newSelectedTFLite._getInputMemoryOffset();
                    console.log(
                        "Input memory offset:",
                        tfliteInfo.inputMemoryOffset
                    );
                    console.log("Input height:", tfliteInfo.inputHeight);
                    console.log("Input width:", tfliteInfo.inputWidth);
                    console.log(
                        "Input channels:",
                        tfliteInfo.inputChannelCount
                    );

                    tfliteInfo.outputMemoryOffset =
                        newSelectedTFLite._getOutputMemoryOffset();
                    tfliteInfo.outputWidth =
                        newSelectedTFLite._getOutputWidth();
                    tfliteInfo.outputHeight =
                        newSelectedTFLite._getOutputHeight();
                    tfliteInfo.outputChannelCount =
                        newSelectedTFLite._getOutputChannelCount();
                    console.log(
                        "Output memory offset:",
                        tfliteInfo.outputMemoryOffset
                    );
                    console.log("Output height:", tfliteInfo.outputHeight);
                    console.log("Output width:", tfliteInfo.outputWidth);
                    console.log(
                        "Output channels:",
                        tfliteInfo.outputChannelCount
                    );

                    tfliteInfo.selectedTFLite = newSelectedTFLite;
                } catch (error) {
                    reject(error);
                    return;
                }
                resolve();
            });
        }

        loadTFLite()
            .then((tflite) => {
                if (tflite === null) {
                    console.error("loadTFLite null");
                    throw "loadTFLite null";
                }
                loadTFLiteModel(tflite)
                    .then((resolved) => {
                        resolve(tfliteInfo);
                    })
                    .catch((err) => {
                        console.error("loadTFLiteModel error");
                        reject("loadTFLiteModel error");
                    });
            })
            .catch((e) => {
                console.error("loadTFLite error:", e);
                reject("loadTFLite error:" + e);
            });
    });

    return promise;
}
